var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2, _path3, _path4, _path5, _path6, _g, _circle6, _path7, _rect, _g2, _circle7, _path8, _circle8, _rect2, _rect3, _g3, _circle9, _path9, _rect4, _rect5, _g4, _circle0, _path0, _rect6, _rect7, _path1, _circle1, _circle10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFeatureWorkflow = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 360,
    viewBox: "0 0 480 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "card",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFC658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ribbon",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FBB024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hdr",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2B4CC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A79F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plat",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5A82F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B4CC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "platRim",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#233F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16265A"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ds",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 7,
    stdDeviation: 9,
    floodColor: "#141C3A",
    floodOpacity: 0.22
  })), /*#__PURE__*/React.createElement("filter", {
    id: "dsm",
    x: "-60%",
    y: "-60%",
    width: "220%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 5,
    floodColor: "#141C3A",
    floodOpacity: 0.2
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 4,
    fill: "#FBB024",
    opacity: 0.85
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 300,
    r: 4,
    fill: "#FFFFFF",
    opacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 250,
    r: 3,
    fill: "#FFFFFF",
    opacity: 0.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 90,
    r: 3.5,
    fill: "#FBB024",
    opacity: 0.7
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 250,
    r: 6,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    opacity: 0.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 156 246 Q 172 182 186.49484661058625 194.68299078426296",
    fill: "none",
    stroke: "#FBB024",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 186.49484661058625 194.68299078426296 L 195.46801471931138 195.37743595312682 M 186.49484661058625 194.68299078426296 L 188.37427475699005 203.4845673386369",
    stroke: "#FBB024",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 298 176 Q 314 112 328.49484661058625 124.68299078426297",
    fill: "none",
    stroke: "#FBB024",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 328.49484661058625 124.68299078426297 L 337.4680147193114 125.37743595312683 M 328.49484661058625 124.68299078426297 L 330.3742747569901 133.4845673386369",
    stroke: "#FBB024",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 222 222 Q 238 208 253.48467469887933 266.0675301207975",
    fill: "none",
    stroke: "#9FB6F2",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeDasharray: "1 7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 253.48467469887933 266.0675301207975 L 260.546880050133 271.6465314271896 M 253.48467469887933 266.0675301207975 L 250.1381155219293 274.4222019680439",
    stroke: "#9FB6F2",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ds)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 272,
    width: 80,
    height: 52,
    rx: 14,
    fill: "#C9D2EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 268,
    width: 80,
    height: 52,
    rx: 14,
    fill: "url(#card)"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 294,
    r: 13,
    fill: "#4BB970"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 228 294 l 5 5.5 l 10 -11",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 290,
    width: 28,
    height: 6,
    rx: 3,
    fill: "#C3CADE"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ds)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 230,
    width: 116,
    height: 66,
    rx: 14,
    fill: "#C9D2EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 226,
    width: 116,
    height: 66,
    rx: 14,
    fill: "url(#card)"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 259,
    r: 16,
    fill: "#3A68DF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 58 267 L 71 254 l 3 3 L 61 270 Z",
    fill: "#FFFFFF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 268.5,
    r: 1.6,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 250,
    width: 50,
    height: 7,
    rx: 3.5,
    fill: "#C3CADE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 263,
    width: 34,
    height: 6,
    rx: 3,
    fill: "#E4E7F2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ds)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 160,
    width: 116,
    height: 66,
    rx: 14,
    fill: "#C9D2EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 156,
    width: 116,
    height: 66,
    rx: 14,
    fill: "url(#card)"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 189,
    r: 16,
    fill: "#43979B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 199 182 h 18 a 3 3 0 0 1 3 3 v 8 a 3 3 0 0 1 -3 3 h -10 l -5 4 v -4 h -3 a 3 3 0 0 1 -3 -3 v -8 a 3 3 0 0 1 3 -3 Z",
    fill: "#FFFFFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 180,
    width: 50,
    height: 7,
    rx: 3.5,
    fill: "#C3CADE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 193,
    width: 34,
    height: 6,
    rx: 3,
    fill: "#E4E7F2"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ds)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 90,
    width: 116,
    height: 66,
    rx: 14,
    fill: "#C9D2EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 86,
    width: 116,
    height: 66,
    rx: 14,
    fill: "url(#card)"
  }))), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 119,
    r: 16,
    fill: "#FBB024"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M 342 119 l 5 5.5 l 10 -11",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 374,
    y: 110,
    width: 50,
    height: 7,
    rx: 3.5,
    fill: "#C3CADE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 374,
    y: 123,
    width: 34,
    height: 6,
    rx: 3,
    fill: "#E4E7F2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M 64 191 l 2.4 6.6 l 6.6 2.4 l -6.6 2.4 l -2.4 6.6 l -2.4 -6.6 l -6.6 -2.4 l 6.6 -2.4 Z",
    fill: "#FBB024"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 188,
    r: 3,
    fill: "#FFC658"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 214,
    r: 2.4,
    fill: "#FFC658"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFeatureWorkflow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/feature_workflow.4f35ae6fb1ed92899630fa48ce944bbd.svg";